/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Meta_TitleInputs */

const es_exp_mk_meta_title = /** @type {(inputs: Exp_Mk_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travesías compartidas | Zarpar Experiencias`)
};

const gl_exp_mk_meta_title = /** @type {(inputs: Exp_Mk_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travesías compartidas | Zarpar Experiencias`)
};

const en_exp_mk_meta_title = /** @type {(inputs: Exp_Mk_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared trips | Zarpar Experiences`)
};

/**
* | output |
* | --- |
* | "Shared trips \| Zarpar Experiences" |
*
* @param {Exp_Mk_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_meta_title = /** @type {((inputs?: Exp_Mk_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_meta_title(inputs)
	if (locale === "en") return en_exp_mk_meta_title(inputs)
	return es_exp_mk_meta_title(inputs)
});